import { List } from 'immutable'
import * as React from 'react'
import { LinkButton } from './library/button'
import { partition } from '../../../Shared/utils/list'
import { Link } from './library/link'

export interface SubscriptionItem {
  readonly title: string
  readonly price: string
  readonly sticker?: string
  readonly extra?: string
  readonly materials: string
  readonly services?: string
  readonly linkUrl: string
  readonly linkTitle: string
  readonly isYouth: boolean
}
export interface SubscriptionsBlockProps {
  readonly kind: 'subscription_block'
  items: List<SubscriptionItem>
}

export const SubscriptionsBlock = (props: SubscriptionsBlockProps): JSX.Element => {
  const [youthTiers, adultTiers] = partition(props.items, x => x.isYouth)

  return (
    <section className="block block--subscriptions container--mg align--center">
      <ul className="block__inner">
        <li className="block__group">
          {adultTiers.count() > 0 ? (
            <>
              {youthTiers.isEmpty() ? <></> : <h2 className="block__title title--s">Ben je 18 jaar of ouder?</h2>}

              <ul
                className={`block__list block__list--${
                  adultTiers.count() > 1 ? 'multiple' : 'single'
                } count--${adultTiers.count()}`}
              >
                {adultTiers.map(item => (
                  <li className="block__item subscription" key={item.title}>
                    <Link className="subscription__inner" url={item.linkUrl}>
                      <div className="subscription__content">
                        <div className="subscription__header title--m">
                          {item.sticker && <span className="subscription__sticker">{item.sticker}</span>}
                          <h3 className="subscription__title">{item.title}</h3>
                        </div>

                        <hr></hr>

                        <div className="subscription__wrap">
                          <div className="subscription__benefits">
                            <span className="sr-text">{'Voordelen van het ' + item.title + ' abonnement: '}</span>

                            {item.services && (
                              <div
                                className="subscription__text text--styled text--s"
                                dangerouslySetInnerHTML={{ __html: item.services }}
                              />
                            )}
                            <div
                              className="subscription__text text--styled text--s"
                              dangerouslySetInnerHTML={{ __html: item.materials }}
                            />
                          </div>

                          <div className="subscription__costs">
                            <div className="subscription__bg">
                              <span className="sr-text">Kosten van het abonnement: </span>
                              <p className="subscription__price title--l">{item.price}</p>
                              <p className="subscription__label text--xs">{item.extra}</p>
                            </div>

                            {adultTiers.count() == 1 && (
                              <LinkButton
                                route={item.linkUrl}
                                className="button button--secondary button--arrow subscription__button"
                              >
                                <span className="button__label">{item.linkTitle}</span>
                              </LinkButton>
                            )}
                          </div>

                          <LinkButton
                            route={item.linkUrl}
                            className="button button--secondary button--arrow subscription__button"
                          >
                            <span className="button__label">{item.linkTitle}</span>
                          </LinkButton>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <></>
          )}
        </li>

        <li className="block__group">
          {youthTiers.count() > 0 ? (
            <>
              <h2 className="block__title title--s">Ben je jonger dan 18 jaar?</h2>
              <ul
                className={`block__list block__list--${
                  youthTiers.count() > 1 ? 'multiple' : 'single'
                } count--${youthTiers.count()}`}
              >
                {youthTiers.map(item => (
                  <li className="block__item subscription" key={item.title}>
                    <Link className="subscription__inner" url={item.linkUrl}>
                      <div className="subscription__content">
                        <div className="subscription__header title--m">
                          {item.sticker && <span className="subscription__sticker">{item.sticker}</span>}
                          <h3 className="subscription__title">{item.title}</h3>
                        </div>

                        <div className="subscription__wrap">
                          <div className="subscription__benefits">
                            <span className="sr-text">{'Voordelen van het ' + item.title + ' abonnement: '}</span>

                            <div
                              className="subscription__text text--styled text--s"
                              dangerouslySetInnerHTML={{ __html: item.materials }}
                            />
                            {item.services && (
                              <div
                                className="subscription__text text--styled text--s"
                                dangerouslySetInnerHTML={{ __html: item.services }}
                              />
                            )}
                          </div>

                          <div className="subscription__costs">
                            <div className="subscription__bg">
                              <span className="sr-text">Kosten van het abonnement: </span>
                              <p className="subscription__price title--l">{item.price}</p>
                              <p className="subscription__label text--xs">{item.extra}</p>
                            </div>

                            {youthTiers.count() == 1 && (
                              <LinkButton
                                route={item.linkUrl}
                                className="button button--secondary button--arrow subscription__button"
                              >
                                <span className="button__label">{item.linkTitle}</span>
                              </LinkButton>
                            )}
                          </div>

                          <LinkButton
                            route={item.linkUrl}
                            className="button button--secondary button--arrow subscription__button"
                          >
                            <span className="button__label">{item.linkTitle}</span>
                          </LinkButton>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <></>
          )}
        </li>
      </ul>
    </section>
  )
}

{
  /* TH: Added to styleguide! */
}
